import React, { Component } from "react";
import ArrowForwardIos from "@material-ui/icons/ArrowForwardIos";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Button from "../../components/CustomButtons/Button.jsx";
import logo from "../../images/dut.png";
import finish from "../../images/imgfinish.png";
import TextField from "@material-ui/core/TextField";
import emailjs from "emailjs-com";
import { Link } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import errorImg from "../../images/error.png";
import Grid from '@material-ui/core/Grid';

export default class Finish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bienvenido: true,
      send: false,
      name: "",
      web: "",
      phone: null,
      him: false,
      modalErrorStatus: false
    };
  }

  componentDidMount() { }

  _img = () => {
    return (
      <div>
        <img src={finish} style={{ width: "100%", height: "100%" }} />
      </div>
    );
  };

  _bienvenido = () => {
    return (
      <div
        style={{
          width: "100%",
          backgroundColor: "#fafafa",
          margin: "auto",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: 80
        }}
      >
        <Typography
          style={{
            color: "#585858",
            fontSize: 27,
            fontFamily: "Muli",
            fontWeight: 600,
            width: "100%",
            marginBottom: 15
          }}
        >
          ¡Bienvenido a tu entorno!
        </Typography>
        <Typography
          style={{
            color: "#585858",
            fontSize: 18,
            fontFamily: "Muli",
            fontWeight: 300,
            width: "100%",
            marginBottom: 15
          }}
        >
          Ya estamos creando tu entorno.
        </Typography>
        <Typography
          style={{
            color: "#585858",
            fontSize: 18,
            fontFamily: "Muli",
            fontWeight: 300,
            width: "50%",
            alignItems: "center",
            margin: "auto"
          }}
        >
          Mientras tanto, necesitamos unos datos de tu negocio para ayudarte de
          la mejor manera.
        </Typography>
        <Button
          style={{
            padding: 10,
            backgroundColor: "#F50027",
            borderRadius: 7,
            marginTop: 20
          }}
          onClick={() => {
            this.setState({
              bienvenido: !this.state.bienvenido,
              send: !this.state.send
            });
          }}
        >
          <Typography
            style={{ fontSize: 14, color: "#fff", textTransform: "capitalize" }}
          >
            Continuar
          </Typography>
          <ArrowForwardIos style={{ fontSize: 15 }} />
        </Button>
      </div>
    );
  };

  _him = () => {
    return (
      <div
        style={{
          width: "100%",
          backgroundColor: "#fafafa",
          margin: "auto",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: 80
        }}
      >
        <Typography
          style={{
            color: "#585858",
            fontSize: 27,
            fontFamily: "Muli",
            fontWeight: 600,
            width: "100%",
            marginBottom: 15
          }}
        >
          El entorno se está creando
        </Typography>
        <Typography
          style={{
            color: "#585858",
            fontSize: 18,
            fontFamily: "Muli",
            fontWeight: 300,
            width: "60%",
            alignItems: "center",
            margin: "auto"
          }}
        >
          Una vez que se haya creado nos contactaremos para que pueda comenzar
          su prueba gratuita por 14 días.
        </Typography>
      </div>
    );
  };

  _sendMail = () => {
    return (
      <div
        style={{
          width: "100%",
          backgroundColor: "#fafafa",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Grid container={1} style={{ justifyContent: 'center', alignItems: 'center' }}>
          <Grid item xs={12} sm={8}>
            <Card style={{ backgroundColor: "#fff" }}>
              <CardContent>
                <TextField
                  id="standard-name"
                  label="Nombre"
                  style={{ width: "100%", marginTop: 0, marginBottom: 0 }}
                  className={useStyles.textField}
                  value={this.state.name}
                  inputProps={{
                    onChange: e => {
                      this.setState({ name: e.target.value });
                    },
                    type: "text"
                  }}
                  margin="normal"
                />
                <TextField
                  id="standard-web"
                  label="Página web"
                  style={{ width: "100%", marginTop: 0, marginBottom: 0 }}
                  className={useStyles.textField}
                  value={this.state.web}
                  inputProps={{
                    onChange: e => {
                      this.setState({ web: e.target.value });
                    },
                    type: "text"
                  }}
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Teléfono"
                  style={{ width: "100%", marginTop: 0, marginBottom: 0 }}
                  className={useStyles.textField}
                  value={this.state.phone}
                  inputProps={{
                    onChange: e => {
                      this.setState({ phone: e.target.value });
                    },
                    type: "number"
                  }}
                  margin="normal"
                />
              </CardContent>
              <CardContent style={{ padding: 10 }}>
                <Button
                  style={{
                    padding: 10,
                    backgroundColor: "#F50027",
                    borderRadius: 7,
                    marginTop: 20,
                    paddingLeft: 25,
                    paddingRight: 25
                  }}
                  onClick={() => {
                    this.sendEmail();
                  }}
                >
                  <Typography
                    style={{
                      fontSize: 14,
                      color: "#fff",
                      textTransform: "capitalize"
                    }}
                  >
                    Enviar
              </Typography>
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  };

  modalError = () => {
    return (
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={useStyles.modalErrorStatus}
        open={this.state.modalErrorStatus}
        onClose={() => {
          this.setState({ modalErrorStatus: false });
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Card
          style={{
            margin: "auto",
            marginTop: 100,
            width: 350,
            height: 320,
            alignItems: "center"
          }}
        >
          <CardContent className="textCardNov2"></CardContent>
          <CardMedia
            style={{
              height: "50%",
              width: "50%",
              margin: "auto",
              backgroundSize: "contain"
            }}
            className="textCardNov2"
            image={errorImg}
            title="error"
          ></CardMedia>
          <CardContent
            className="textCardNov2"
            style={{
              textAlign: "center !important",
              alignContent: "center !important"
            }}
          >
            <Typography
              className="titCard"
              style={{ textAlign: "center" }}
              gutterBottom
              variant="h5"
              component="h2"
            >
              Error
            </Typography>
            <Typography
              variant="txtCardNov"
              color="textSecondary"
              component="p"
            >
              Debes completar todos los campos.
            </Typography>
            <Button
              className="btn2"
              onClick={() => {
                this.setState({ modalErrorStatus: false });
              }}
            >
              <Typography className="btnNewNov2">ACEPTAR</Typography>
            </Button>
          </CardContent>
        </Card>
      </Modal>
    );
  };

  sendEmail = () => {
    if (!this.state.web || !this.state.name) {
      this.setState({ modalErrorStatus: true });
    } else {
      const templateParams = {
        name: this.state.name,
        webPage: this.state.web,
        phone: this.state.phone,
      };
      emailjs
        .send(
          "zoho",
          "template_UQPYyTuZ",
          templateParams,
          "user_U8zJLss8xHysHhuIkSy0V"
        )
        .then(
          response => {
            console.log("SUCCESS!", response.status, response.text);
          },
          err => {
            console.log("FAILED...", err);
          }
        );
      this.setState({ send: !this.state.send, him: !this.state.him });
    }
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        {this.modalError()}
        <header className="App-header1">
          <Link to="/">
            <img src={logo} className="App-logo" alt="logo" />
          </Link>
        </header>
        <div
          style={{
            width: 250,
            height: 250,
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            marginTop: 30
          }}
        >
          {this._img()}
        </div>
        {this.state.bienvenido ? (
          <div
            style={{
              width: "100%",
              height: 250,
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
              marginTop: 30
            }}
          >
            {this._bienvenido()}
          </div>
        ) : null}
        {this.state.send ? (
          <div
            style={{
              height: 250,
              justifyContent: "center",
              alignItems: "center",
              marginTop: 30,
              marginBottom: 100,
              padding: 10
            }}
          >
            {this._sendMail()}
          </div>
        ) : null}
        {this.state.him ? (
          <div
            style={{
              width: "60%",
              height: 250,
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
              marginTop: 50
            }}
          >
            {this._him()}
          </div>
        ) : null}
      </div>
    );
  }
}

const useStyles = makeStyles(theme => ({
  textField: {
    width: "100%",
    marginTop: 0,
    fontSize: 15
  }
}));
